import { useLanguage } from "@/i18n/LanguageContext";

const types = [
  {
    title: "Single-Pane Glass",
    description: "Standard residential window glass.",
  },
  {
    title: "Basic Double-Pane",
    description: "Non-impact insulated, failed seal.",
  },
  {
    title: "Picture Window Glass",
    description: "Fixed-pane non-impact glass.",
  },
  {
    title: "Storm Door Glass",
    description: "Storm and screen door panels.",
  },
  {
    title: "Cabinet Glass",
    description: "China cabinet, display case glass.",
  },
  {
    title: "Tabletop Glass",
    description: "Custom-cut tempered for tables.",
  },
];

export default function WhatWeReplace() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-roboto font-bold text-2xl md:text-[32px] text-[#064e3b] mb-3">
            {t("glass.servicesH2")}
          </h2>
          <p className="text-gray-600 text-base max-w-[720px] mx-auto">
            Non-impact glass in existing frames. Not impact or HVHZ glass.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {types.map((t) => (
            <div
              key={t.title}
              className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm border-t-4 border-t-[#047857]"
            >
              <h3 className="font-bold text-base text-[#064e3b] mb-2">{t.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{t.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}